import styled from "styled-components";
import { COLORS } from "../../../../styles/constants.style";

export const CreateClientActivitiesAndDeliverablesWrapper = styled.div`
  .cell-activity-type {
    min-width: 200px;
  }
  .cell-modality {
    min-width: 160px;
  }
  .cell-topics {
    min-width: 260px;
  }
  .cell-activity-status {
    min-width: 200px;
  }
  .cell-units {
    min-width: 150px;
  }
  .cell-measurement {
    min-width: 200px;
  }
  .cell-candidate-status {
    min-width: 200px;
  }
  .cell-actions {
    min-width: 140px;
  }
  .form-header-right > .MuiBox-root {
    margin-right: 28px;
    display: flex;
    justify-content: flex-end;
  }

  .action-btns {
    margin: 0 16px;
  }
  .ellipsis-with-tooltip {
    width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .semi-header {
    display: flex;
    padding: 16px 28px;
    justify-content: flex-end;
  }
`;
export const DiscardMessageWrapper = styled.div`
  .confirm-message {
    color: ${COLORS.cirrus_black10};
  }
`;
